import ReactCountdown from 'react-countdown';
import './Countdown.scss';

const getDaysWord = (days) => {
  const lastDigit = days % 10;
  const lastTwoDigits = days % 100;

  if (lastTwoDigits >= 11 && lastTwoDigits <= 19) return 'дней';
  if (lastDigit === 1) return 'день';
  if (lastDigit >= 2 && lastDigit <= 4) return 'дня';
  return 'дней';
};

const getHoursWord = (hours) => {
  const lastDigit = hours % 10;
  const lastTwoDigits = hours % 100;

  if (lastTwoDigits >= 11 && lastTwoDigits <= 19) return 'часов';
  if (lastDigit === 1) return 'час';
  if (lastDigit >= 2 && lastDigit <= 4) return 'часа';
  return 'часов';
};

const getMinutesWord = (minutes) => {
  const lastDigit = minutes % 10;
  const lastTwoDigits = minutes % 100;

  if (lastTwoDigits >= 11 && lastTwoDigits <= 19) return 'минут';
  if (lastDigit === 1) return 'минута';
  if (lastDigit >= 2 && lastDigit <= 4) return 'минуты';
  return 'минут';
};

const getSecondsWord = (seconds) => {
  const lastDigit = seconds % 10;
  const lastTwoDigits = seconds % 100;

  if (lastTwoDigits >= 11 && lastTwoDigits <= 19) return 'секунд';
  if (lastDigit === 1) return 'секунда';
  if (lastDigit >= 2 && lastDigit <= 4) return 'секунды';
  return 'секунд';
};

const pad = (n) => String(n).padStart(2, '0');

const renderer = ({ days, hours, minutes, seconds, completed }) => {
  if (completed) {
    return <div className="countdown__completed">Свадьба состоялась!</div>;
  }

  return (
    <div className="countdown__wrapper">
      <div className="countdown__unit">
        <div className="countdown__number">{days}</div>
        <div className="countdown__label">{getDaysWord(days)}</div>
      </div>
      <div className="countdown__divider"></div>
      <div className="countdown__unit">
        <div className="countdown__number">{pad(hours)}</div>
        <div className="countdown__label">{getHoursWord(hours)}</div>
      </div>
      <div className="countdown__divider"></div>
      <div className="countdown__unit">
        <div className="countdown__number">{pad(minutes)}</div>
        <div className="countdown__label">{getMinutesWord(minutes)}</div>
      </div>
      <div className="countdown__divider"></div>
      <div className="countdown__unit">
        <div className="countdown__number">{pad(seconds)}</div>
        <div className="countdown__label">{getSecondsWord(seconds)}</div>
      </div>
    </div>
  );
};

const Countdown = ({ targetDate }) => {
  return (
    <section className="countdown">
       <div className="countdown__container">
          <h2 className="countdown__title">До нашей свадьбы осталось</h2>
          <ReactCountdown date={new Date(targetDate)} renderer={renderer}/>
       </div>
    </section>
  );
};

export default Countdown;
